import { PAYMENT_FREQUENCY } from '@ahmdigital/constants';

export const PAYMENT_FREQUENCY_OPTIONS = [
  PAYMENT_FREQUENCY.WEEKLY,
  PAYMENT_FREQUENCY.FORTNIGHTLY,
  PAYMENT_FREQUENCY.MONTHLY,
  PAYMENT_FREQUENCY.YEARLY,
];
